interface GraphQLResponse<T> {
  data?: T;
  errors?: Array<{ message: string }>;
}

const endpoint = `${import.meta.env.VITE_API_URL ?? ""}/graphql`;

export async function graphql<T>(
  query: string,
  variables: Record<string, unknown> = {},
  token?: string,
): Promise<T> {
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ query, variables }),
  });
  const body = (await response.json()) as GraphQLResponse<T>;
  if (!response.ok || body.errors?.length || !body.data) {
    throw new Error(body.errors?.map((item) => item.message).join("; ") || "API request failed");
  }
  return body.data;
}

